import { render, staticRenderFns } from "./SliceTypographicAbout.vue?vue&type=template&id=9167c89e&lang=pug&"
import script from "./SliceTypographicAbout.vue?vue&type=script&lang=js&"
export * from "./SliceTypographicAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports